<!--
To use this template simply use the tag <hydroware-checkbox-group>
the properties that are used by the hydroware-checkbox-group are:
   title -  this value goes in the heading of the checkbox group
   :choices - this is the list of items for the checkboxes in the checkbox group (NOTE THE ":")
   v-model - this is the list of checkboxes that are chosen (NOTE: it is the 'value' property in this template)
   varForDisplayedValue - this is an attribute in the rows of 'choices' and is used for the checkbox's label
        AND for the value that is displayed for the list of checkboxdes
   varForKey - this is an attribute in the rows of 'choices' and is used for the checkbox's key
   disableChoices - when set to true all fo the choices in the group are disabled
-->
<template>
  <div>
    <div class="col-xs-12 hydroware-container-heading">
      <table style=width:100%>
        <tr>
          <td style="text-align:left;">
            <slot name="header_title">
              <div style="font-size:2em;" v-if="title !== null">
                {{title}}
              </div>
            </slot>
          </td>
          <td style="text-align:right;">
            <slot name="after_header_title">
              after the title
            </slot>
          </td>
        </tr>
      </table>
    </div> <!--end of heading -->
    <div class="col-xs-12 hydroware-container-body">
      <el-checkbox-group 
        :disabled=disableChoices
        v-model=value
        v-bind=[$attrs,$props] 
        v-on="$listeners"
        >
        <el-checkbox class="hydroware-checkbox"
          v-for="oneCheckbox in choices"
            :label="oneCheckbox[varForLabel]" 
            :key="oneCheckbox[varForKey]" 
            :value="oneCheckbox">
            {{oneCheckbox[varForDisplayedValue]}}
        </el-checkbox>
      </el-checkbox-group>
    </div> <!--end of body-->
  </div>
</template>
<script>
export default {
    props: ['title', 'choices', 'chosen', 'varForDisplayedValue', 'varForKey', 'varForLabel','value','disableChoices'],
    methods: {
    }
  }
</script> 


// WEBPACK FOOTER //
// hydroware-checkbox-group.vue?d24b1d88